import { createSelector } from '@reduxjs/toolkit';
import get from 'lodash/get';

export const sidebarMenuSelector = createSelector(
  (state) => get(state, 'sidebarMenu', {}),
  (sidebarMenu) => get(sidebarMenu, 'data', {}),
);

export const openSidebarMenuSelector = createSelector(
  (state) => get(state, 'sidebarMenu', {}),
  (sidebarMenu) => sidebarMenu.open,
);

export const availableSidebarMenuSelector = createSelector(
  (state) => get(state, 'sidebarMenu', {}),
  (sidebarMenu) => sidebarMenu.available,
);
